var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canClose)?_c('div',[_c('button',{staticClass:"button CloseButton",class:_vm.size,style:(_vm.customColor),on:{"click":_vm.handleCloseButtonClick}},[_vm._v(_vm._s(_vm.label))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }